export default __webpack_public_path__ + "static/media/85.902b3f9b.svg";